import { GoogleSession, OneLoginSession } from '../../types'
import { saveSession } from './saveSession'

export function login(session: GoogleSession | OneLoginSession) {
  saveSession({
    ...session,
    loggedInAt: Date.now(),
  })
}
